import { getView } from '@/lib/utils';

export default {
  path: '/access-denied',
  name: 'accessDenied',
  component: getView('pages/PageAccessDenied'),
};
